import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { HUB_API_SETTINGS_TOKEN } from '../../hub-api-settings-token';
import { HubApiSettingsService } from '../../hub-api-settings.service';

import { AddStaffToTimesheetPeriodCommand } from '../model/command/add-staff-to-timesheet-period-command';
import { DeleteStaffFromTimesheetPeriodCommand } from '../model/command/delete-staff-from-timesheet-period-command';
import { EditTimesheetPeriodCommand } from '../model/command/edit-timesheet-period-command';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

// Generated service for sending Timesheet commands to the API.
@Injectable()
export class TimesheetCommandService {

  constructor(
    private http: HttpClient,
    private settingsService: HubApiSettingsService,
  ) { }

  AddStaffToTimesheetPeriodCommand(commandData: AddStaffToTimesheetPeriodCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Timesheet.AddStaffToTimesheetPeriodCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  DeleteStaffFromTimesheetPeriodCommand(commandData: DeleteStaffFromTimesheetPeriodCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Timesheet.DeleteStaffFromTimesheetPeriodCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  EditTimesheetPeriodCommand(commandData: EditTimesheetPeriodCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Timesheet.EditTimesheetPeriodCommand'
      },
    };
    return this.http.request('POST', url, options);
  }
}
